import { Model } from '@vuex-orm/core'

export default class User extends Model {
  static entity = 'users'

  static fields () {
    return {
      // Models
      id: this.attr(null),
      email: this.string(''),
      token: this.string(null),
      description: this.attr(null),
      lastname: this.string(''),
      name: this.string(''),
      plan_subscribed_at: this.attr(null),
      pricing_plan_id: this.attr(null),
      provider_ids: this.attr(null),
      subscription_ids: this.attr(null),
      title: this.attr(null),
      unconfirmed_phone: this.attr(null),
      created_at: this.attr(null),
      updated_at: this.attr(null),
      is_admin: this.attr(null)
    }
  }
}
